import { useDriverLangMaybe } from "@/context/DriverLanguageContext";

export default function FullWidthImageLightbox({ src, alt, label, onClose }) {
  const driverLang = useDriverLangMaybe();
  const closeLabel = driverLang?.t("close") ?? "Close";
  const photoLabel = driverLang?.t("photoLabel") ?? "Photo";

  if (!src) return null;

  return (
    <div
      className="driver-lightbox"
      role="dialog"
      aria-modal="true"
      aria-label={label || alt || photoLabel}
      onClick={onClose}
    >
      <div className="driver-lightbox-inner" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="driver-lightbox-close" onClick={onClose}>
          {closeLabel}
        </button>
        {label ? <p className="driver-lightbox-label">{label}</p> : null}
        <img src={src} alt={alt || label || photoLabel} className="driver-lightbox-img" />
      </div>
    </div>
  );
}
